import React, { useState } from "react";
import { Engines, FeaturesImage } from "../../assets";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { EngineCard, Sparkels } from "../../Components";

const Features = (props) => {

    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
      });
    
    return (
      <div >
      <div className={`${styles["hero-spacer"]}`} />
      <div
        key={scrollPos}
        className={`${styles["content-section"]}`}
      >
        <h3 className={`${styles.title}`}>
          Analyze Like Never Before
        </h3>
        <Sparkels />
        <p className={`${styles.subp} pb-5`}>
          Our dedicated servers provide incredible calculation speeds across all modern engines. With our platform you can get instant access to dedicated computer hardware .
          Unlock the best analysis experience of your lives now !
        </p>
        <div style={{width: '80%'}} className={`ml-[10%] h-[50%] gap-5 sm:gap-0 flex sm:flex-row flex-col items-center justify-center sm:justify-between w-full relative bottom-[${props.width < 1450 ? '15vh' : '25vh'}]`}>
        <EngineCard type={1}/>
        <EngineCard type={2}/>
        </div>
        {/*props.width > 780 && <><div className={`${styles.triangle} left-[-180px]`}/>
      <div style={{transform: 'scaleX(-1) rotate(225deg) '}} className={`${styles.triangle} right-[-250px]`}/></>*/}
      </div>
      
        </div>
    )
}

export default Features;